import React from "react";
import Icon from "../icon/Icon";

export default function CustomHeaderLogoMedia() {
  return (
    <Icon name={"media-logo"}/>
  )
}
